import { IdentityProviderModel } from "../../hickory-api";
import { ApiConfig } from "../../shared/api-config/api-config";
import { BaseDataSource, TableColumn } from "../../shared/data-table/datasource/datasource";
import { IdentityProvidersHelperService } from "../identity-providers-helper.service";
import { IdentityProviderTableContext } from './identity-provider-table-context';

export abstract class IdentityProvidersDataSource extends BaseDataSource<IdentityProviderModel, IdentityProvidersHelperService, { tenantId?: number }> {
  protected columns: TableColumn<IdentityProviderModel>[];
  get availableColumns(): TableColumn<IdentityProviderModel>[] {
    return [
      {
        field: 'name',
        localizationKey: 'IdentityProviders.Columns.Name',
        render(model: IdentityProviderModel) {
          return model?.name
        },
        noSort: true
      },
      {
        field: 'scheme',
        localizationKey: 'IdentityProviders.Columns.Scheme',
        render(model: IdentityProviderModel) {
          return model?.scheme
        },
        noSort: true
      },
    ]
  }
  get queryArguments(): object {
    const request = this.currentRequest.value;
    return {
      tenantId: request?.tenantId ?? +ApiConfig.tenantId
    }
  }
}

export class SystemIdentityProvidersDataSource extends IdentityProvidersDataSource {

  constructor(service: IdentityProvidersHelperService) {
    super(service, null, null, {}, false);
  }

  public loadData(_: boolean): void {
    this.service.getSystemProviders().subscribe(providers => {
      this.dataSubject.next(providers || []);
    });
  }
}

export class TenantIdentityProvidersDataSource extends IdentityProvidersDataSource {

  private readonly featureEnabled: boolean = false;
  private readonly tenantId: number = null;

  constructor(service: IdentityProvidersHelperService, context: IdentityProviderTableContext) {
    const tenantId = context?.tenantId ?? +ApiConfig.tenantId;
    super(service, null, null, { tenantId }, true);
    this.featureEnabled = context?.featureEnabled;
    this.tenantId = tenantId;
  }

  public loadData(_: boolean): void {
    if (this.featureEnabled) {
      this.service.tenantProviders(this.tenantId).subscribe(providers => {
        this.dataSubject.next(providers || []);
      });
    } else {
      this.dataSubject.next([]);
    }
  }
}